module.exports = __webpack_public_path__ + "static/media/distribution.1b4b3e60.jpeg";